import VpsOfferCard from './VpsOfferCard'

export default VpsOfferCard
